// src/components/blog/CategoryFilter.tsx
//
// Client-side chip filter for the blog index. "All" resets the filter to
// null. The chosen category is reported to the parent via onChange.

'use client'

import type { BlogCategory } from '@/lib/content/blog-types'
import { BLOG_CATEGORIES } from '@/lib/content/blog-types'

export interface CategoryFilterProps {
  active: BlogCategory | null
  onChange: (next: BlogCategory | null) => void
}

export default function CategoryFilter({ active, onChange }: CategoryFilterProps) {
  const chips: Array<{ key: string; label: string; value: BlogCategory | null }> = [
    { key: 'all', label: 'All', value: null },
    ...BLOG_CATEGORIES.map((c) => ({ key: c, label: c, value: c })),
  ]

  return (
    <div
      role="group"
      aria-label="Filter blog posts by category"
      className="flex flex-wrap items-center gap-2"
    >
      {chips.map((chip) => {
        const isActive = chip.value === active
        return (
          <button
            key={chip.key}
            type="button"
            onClick={() => onChange(chip.value)}
            aria-pressed={isActive}
            className={
              'rounded-full border px-3.5 py-1.5 text-sm font-medium transition ' +
              (isActive
                ? 'border-brand/60 bg-brand/20 text-brand-ink'
                : 'border-border bg-card/40 text-muted-foreground hover:border-border hover:text-foreground')
            }
          >
            {chip.label}
          </button>
        )
      })}
    </div>
  )
}
